import React from "react";
import { TestLanguage } from "../hooks/testLanguage";
import { TbWorldWww } from "react-icons/tb";
import { MdEmail } from "react-icons/md";
import { FaSquarePhone } from "react-icons/fa6";
import { FaLocationDot } from "react-icons/fa6";

const DeveloperInformation = ({ i }) => {
  const ln = localStorage.getItem("lang");
  const language = ln == "ar" ? "ar" : "en";
  return (
    <div
      style={{
        direction: language == "ar" ? "rtl" : "ltr",
        // margin: "100px",
        // width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        padding:'100px'
      }}
    >
      <img
        src={process.env.REACT_APP_IMAGE + i.developer_image}
        style={{ borderRadius: "50%", width: "300px",height:'300px', margin: "20px", }}
      />
      <div>
        <h1>{TestLanguage(i, "developer_name")}</h1>
        <h5>
          <FaLocationDot size={22} /> {TestLanguage(i, "developer_address")}
        </h5>
        <p style={{textAlign:'justify'}}>{TestLanguage(i, "developer_description")}</p>
        <div
          style={{
            marginTop: "20px",
            display: "flex",
            direction: "ltr",
            justifyItems: "flex-start",
            justifyContent: "space-between",
            alignItems: "center",
            width: "60vw",
            color: "gray",

          }}
        >
          <h5 style={{color:"black"}}>
            <TbWorldWww size={22} /> {i?.developer_website}
          </h5>
          <h5 style={{color:"black"}}>
            {" "}
            <FaSquarePhone size={22} /> {i?.developer_phone}
          </h5>
          <h5 style={{color:"black"}}>
            <MdEmail size={22} /> {i?.developer_email}
          </h5>
        </div>
      </div>
    </div>
  );
};

export default DeveloperInformation;
